'use client'

import React, { useState } from 'react'
import { useKeenSlider } from 'keen-slider/react'
import 'keen-slider/keen-slider.min.css'
import { faAngleLeft, faAngleRight, FontAwesomeIcon } from '@/constants/icons'

interface Props {
    children: React.ReactNode
}

const TrendingMerchantsSlider = ({ children }: Props) => {
    const [currentSlide, setCurrentSlide] = useState(0)
    const [loaded, setLoaded] = useState(false)

    const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
        loop: false,
        mode: 'free-snap',
        slides: {
            perView: 4,
            spacing: 24,
        },
        breakpoints: {
            '(max-width: 1280px)': {
                slides: {
                    perView: 3.5,
                    spacing: 20,
                },
            },
            '(max-width: 1024px)': {
                slides: {
                    perView: 2.5,
                    spacing: 16,
                },
            },
            '(max-width: 640px)': {
                slides: {
                    perView: 1,
                    spacing: 12,
                },
            },
        },
        drag: true,
        rubberband: false,
        initial: 0,
        created() {
            setLoaded(true)
        },
        slideChanged(s) {
            setCurrentSlide(s.track.details.rel)
        }
    })

    const items = React.Children.toArray(children)

    return (
        <div className="relative w-full group/slider">
            {/* Slider Container */}
            <div ref={sliderRef} className="keen-slider py-4">
                {items.map((child, idx) => (
                    <div key={idx} className="keen-slider__slide">
                        {child}
                    </div>
                ))}
            </div>

            {/* Arrows */}
            {loaded && slider.current && items.length > 4 && (
                <>
                    <button
                        onClick={(e) => {
                            e.stopPropagation()
                            slider.current?.prev()
                        }}
                        className="absolute left-1 lg:left-0 top-1/2 -translate-y-1/2 w-10 h-10 bg-white hover:bg-indigo-600 hover:text-white text-slate-700 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 z-10 border border-slate-100 opacity-100 translate-x-0 lg:opacity-0 lg:-translate-x-4 lg:group-hover/slider:opacity-100 lg:group-hover/slider:translate-x-0"
                        aria-label="Previous slide"
                    >
                        <FontAwesomeIcon icon={faAngleLeft} className="w-4 h-4" />
                    </button>

                    <button
                        onClick={(e) => {
                            e.stopPropagation()
                            slider.current?.next()
                        }}
                        className="absolute right-1 lg:right-0 top-1/2 -translate-y-1/2 w-10 h-10 bg-white hover:bg-indigo-600 hover:text-white text-slate-700 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 z-10 border border-slate-100 opacity-100 translate-x-0 lg:opacity-0 lg:translate-x-4 lg:group-hover/slider:opacity-100 lg:group-hover/slider:translate-x-0"
                        aria-label="Next slide"
                    >
                        <FontAwesomeIcon icon={faAngleRight} className="w-4 h-4" />
                    </button>
                </>
            )}
        </div>
    )
}

export default TrendingMerchantsSlider
